/* eslint-disable */ import { memoEval, priceComponent, sceneEntityRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const swimShortsComponents = [
    attachComponent.withComponent(priceComponent, 'default', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$price
        ], ($price)=>({
            currency: 'USD',
            price: $price
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'shorts', true).withEntity('SwimShorts').attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/swim-shorts.glb',
            objectName: 'SwimShorts',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'stitches', true).withEntity('SwimShorts').attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/swim-shorts.glb',
            objectName: 'SwimShortsStitches',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'linerMesh', true).withEntity('SwimShorts').withGradualFilter({
        active: (self)=>self.$isMeshLiner
    }).attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/swim-shorts.glb',
            objectName: 'SwimShortsLinerMesh',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'linerCompression', true).withEntity('SwimShorts').withGradualFilter({
        active: (self)=>self.$isCompressionLiner
    }).attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/swim-shorts.glb',
            objectName: 'SwimShortsLinerCompression',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'leftLeg', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$leftLegMaterial
        ], ($leftLegMaterial)=>$leftLegMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'rightLeg', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$rightLegMaterial
        ], ($rightLegMaterial)=>$rightLegMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'leftThighBand', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$leftThighBandMaterial
        ], ($leftThighBandMaterial)=>$leftThighBandMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'rightThighBand', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$rightThighBandMaterial
        ], ($rightThighBandMaterial)=>$rightThighBandMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'waistband', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$waistbandMaterial
        ], ($waistbandMaterial)=>$waistbandMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'drawstring', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$drawstringMaterialColor
        ], ($drawstringMaterialColor)=>({
            fileUrl: 'models/swim-shorts.glb',
            materialName: 'LacesMaterial',
            materialsToOverride: [
                'LacesMaterial'
            ],
            color: $drawstringMaterialColor
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'stitches', true).withEntity('SwimShorts').attach(memoEval((self)=>[
            self.$stitchesMaterialColor
        ], ($stitchesMaterialColor)=>({
            fileUrl: 'models/swim-shorts.glb',
            materialName: 'StitchesMaterial',
            materialsToOverride: [
                'StitchesMaterial'
            ],
            color: $stitchesMaterialColor
        })))
];

//# sourceMappingURL=swim-shorts.js.map